import { Button, Form, Title } from 'ui';
import { type PrimaryOrganizationOption, PrimaryOrganizationSelect } from '../primary-organization-select';

type FormValues = {
  organization: PrimaryOrganizationOption;
};

type P = {
  onNext: (organization: PrimaryOrganizationOption) => void;
};

const SignUpOrganization = ({ onNext }: P) => {
  const [form] = Form.useForm<FormValues>();

  const handleSubmit = (values: FormValues) => {
    onNext(values.organization);
  };

  return (
    <Form<FormValues> form={form} onFinish={handleSubmit}>
      <Title level={1} marginBottom>
        Sign up
      </Title>
      <Form.Item<FormValues> label="Select your organization" name="organization" rules={[{ required: true }]}>
        <PrimaryOrganizationSelect />
      </Form.Item>
      <Button block htmlType="submit" type="primary">
        Next
      </Button>
    </Form>
  );
};

export default SignUpOrganization;
